/**
 * Production-safe logger for XSTRONG POWER EV CHARGER app.
 *
 * - In development (yarn start): logs go to the browser console.
 * - In production (yarn build): all log output is suppressed so no
 *   internal details leak to end users or appear in browser DevTools.
 *
 * Usage:
 *   import logger from "@/lib/logger";
 *   logger.error("[Component] action failed:", err?.message);
 */
const isDev = process.env.NODE_ENV !== "production";

const logger = {
  // eslint-disable-next-line no-console
  error: (...args) => { if (isDev) console.error(...args); },
  // eslint-disable-next-line no-console
  warn:  (...args) => { if (isDev) console.warn(...args);  },
  // eslint-disable-next-line no-console
  info:  (...args) => { if (isDev) console.info(...args);  },
};

export default logger;
